{
  "All": "All",
  "actions": {
    "Apply": "Apply",
    "Cancel": "Cancel",
    "Clear": "Clear",
    "Clear selection": "Clear selection",
    "Close": "Close",
    "Confirm": "Confirm",
    "Continue": "Continue",
    "Next": "Next",
    "Previous": "Previous",
    "Reload": "Reload",
    "Save": "Save",
    "Search": "Search",
    "Submit": "Submit"
  },
  "amazonDebug": {
    "Refresh": "Refresh",
    "Last updated: {timestamp}": "Last updated: {timestamp}"
  },
  "barChart": {
    "Other": "Other"
  },
  "breadcrumb": {
    "breadcrumbs": "breadcrumbs"
  },
  "dashboardLinks": {
    "Advertisement Report": "Advertisement Report",
    "Advertising Dashboard": "Advertising Dashboard",
    "Agency Dashboard": "Agency Dashboard",
    "All Customers Dashboard": "All Customers Dashboard",
    "Content Dashboard": "Content Dashboard",
    "Deals Dashboard": "Deals Dashboard",
    "DSP Dashboard": "DSP Dashboard",
    "Goals Dashboard": "Goals Dashboard",
    "Merchandising Dashboard": "Merchandising Dashboard",
    "Organization Summary Report": "Organization Summary Report",
    "Overview": "Overview",
    "Placement": "Placement",
    "Pricing": "Pricing",
    "Pricing Dashboard": "Pricing Dashboard",
    "Pricing Plan Report": "Pricing Plan Report",
    "Product": "Product",
    "Product Ad Report": "Product Ad Report",
    "Product Report": "Product Report",
    "Promotions": "Promotions",
    "Target Report": "Target Report"
  },
  "breadcrumbDates": {
    "Search Term": "Search Term",
    "Group by:": "Group by:",
    "Range:": "Range:",
    "Compare against:": "Compare against:",
    "Start": "Start",
    "End": "End",
    "Include current {group}": "Include current {group}",
    "by {group}": "by {group}",
    "vs. {compare}": "vs. {compare}",
    "groupNames": {
      "Day": "Day",
      "Week": "Week",
      "Month": "Month"
    },
    "compareNames": {
      "Previous Period": "Previous Period",
      "Previous Year": "Previous Year",
      "Custom": "Custom"
    },
    "periodNames": {
      "Last Month": "Last Month",
      "Last Week": "Last Week",
      "Last 7 days": "Last 7 days",
      "Last 14 days": "Last 14 days",
      "Last 30 days": "Last 30 days",
      "Month to Date": "Month to Date",
      "Last 12 weeks": "Last 12 weeks",
      "Last 26 weeks": "Last 26 weeks",
      "Last 6 months": "Last 6 months",
      "Last 12 months": "Last 12 months",
      "Custom": "Custom"
    }
  },
  "bulkActions": {
    "Bulk Actions ({count} selected)": "Bulk Actions ({count} selected)",
    "Confirm Bulk Action": "Confirm Bulk Action"
  },
  "bulkEdit": {
    "Bulk input": "Bulk input",
    "Separate text using commas or new lines": "Separate text using commas or new lines"
  },
  "countries": {
    "Australia": "Australia",
    "Belgium": "Belgium",
    "Brazil": "Brazil",
    "Canada": "Canada",
    "France": "France",
    "Germany": "Germany",
    "India": "India",
    "Ireland": "Ireland",
    "Italy": "Italy",
    "Japan": "Japan",
    "Mexico": "Mexico",
    "Netherlands": "Netherlands",
    "Poland": "Poland",
    "Saudi Arabia": "Saudi Arabia",
    "Singapore": "Singapore",
    "Spain": "Spain",
    "Sweden": "Sweden",
    "Turkey": "Turkey",
    "UAE": "UAE",
    "United Kingdom": "United Kingdom",
    "United States": "United States"
  },
  "navbar": {
    "Account": "Account",
    "Channel": "Channel",
    "Europe": "Europe",
    "Far East": "Far East",
    "Marketplace": "Marketplace",
    "North America": "North America",
    "Other": "Other",
    "Sellers": "Sellers",
    "Vendors": "Vendors"
  },
  "notifications": {
    "All": "All",
    "Budget": "Budget",
    "Buy Box": "Buy Box",
    "Fulfilled by Amazon": "Fulfilled by Amazon",
    "Fulfilled by Manufacturer": "Fulfilled by Manufacturer",
    "No Notifications": "No Notifications",
    "Notifications": "Notifications",
    "on product": "on product",
    "Price": "Price",
    "View Media Plan": "View Media Plan",
    "View Offers": "View Offers",
    "View Pricing Plan": "View Pricing Plan",
    "View Product": "View Product",
    "You have no new notifications": "You have no new notifications"
  },
  "search": {
    "Categories": "Categories",
    "Category": "Category",
    "Content Template": "Content Template",
    "Content Templates": "Content Templates",
    "Digital Shelf": "Digital Shelf",
    "Digital Shelves": "Digital Shelves",
    "Media Plan": "Media Plan",
    "Media Plans": "Media Plans",
    "Pricing Plan": "Pricing Plan",
    "Pricing Plans": "Pricing Plans",
    "Product": "Product",
    "Product Content": "Product Content",
    "Product Launch": "Product Launch",
    "Product Launches": "Product Launches",
    "Products": "Products",
    "Showing Results for \"{query}\"": "Showing Results for \"{query}\"",
    "Top Results": "Top Results",
    "{adCount} Media Plans & {productCount} Products": "{adCount} Media Plans & {productCount} Products"
  },
  "devErrorDisplay": {
    "Copy this error and include it with your bug report.": "Copy this error and include it with your bug report.",
    "Copy": "Copy",
    "Copied!": "Copied!",
    "Error details": "Error details"
  },
  "Could not save your changes. Check your connection and try again.": "Could not save your changes. Check your connection and try again.",
  "Could not save your changes. Please try again.": "Could not save your changes. Please try again.",
  "Download PDF": "Download PDF",
  "formWizard": {
    "Next Step": "Next Step",
    "Previous Step": "Previous Step"
  },
  "maintenance": {
    "The portal is currently down for maintenance": "The portal is currently down for maintenance",
    "If you require immediate assistance please reach out to <supportLink>support</supportLink>.": "If you require immediate assistance please reach out to <supportLink>support</supportLink>."
  },
  "fileDropZone": {
    "Drop your file here or click the button below": "Drop your file here or click the button below",
    "Processing your file...": "Processing your file...",
    "Upload File": "Upload File"
  },
  "language": {
    "Language": "Language"
  },
  "An error occurred.": "An error occurred.",
  "{withGoal} / {total} days with goals": "{withGoal} / {total} days with goals",
  "footer": {
    "Trellis Corporation": "Trellis Corporation"
  },
  "select": {
    "Select...": "Select..."
  },
  "sidebar": {
    "Ad Report": "Ad Report",
    "Advertising": "Advertising",
    "Agency Dashboard": "Agency Dashboard",
    "All Customers": "All Customers",
    "AMC": "AMC",
    "AMC Audiences": "AMC Audiences",
    "Amazon Connect": "Amazon Connect",
    "Assets": "Assets",
    "Audience Report": "Audience Report",
    "BETA": "BETA",
    "Billing": "Billing",
    "Configuration": "Configuration",
    "Connect TRMNL": "Connect TRMNL",
    "Content": "Content",
    "Coupons": "Coupons",
    "Dashboard": "Dashboard",
    "Deals": "Deals",
    "DSP": "DSP",
    "Exports": "Exports",
    "Goals": "Goals",
    "Manage Applications": "Manage Applications",
    "Marketing Intelligence": "Marketing Intelligence",
    "MCP Server": "MCP Server",
    "NEW": "NEW",
    "New Product Launch": "New Product Launch",
    "Placement": "Placement",
    "Pricing": "Pricing",
    "Product": "Product",
    "Product & Categories": "Product & Categories",
    "Product Ad Report": "Product Ad Report",
    "Product Report": "Product Report",
    "Promotions": "Promotions",
    "Report a Bug": "Report a Bug",
    "Report Agents": "Report Agents",
    "Report Card": "Report Card",
    "Team Activity": "Team Activity",
    "Reports": "Reports",
    "Search Analytics": "Search Analytics",
    "Search Query Perf": "Search Query Perf",
    "Search Term Report": "Search Term Report",
    "Settings": "Settings",
    "Shopify Connect": "Shopify Connect",
    "Staff Tools": "Staff Tools",
    "Summary Report": "Summary Report",
    "Switch Profiles": "Switch Profiles",
    "Target Report": "Target Report",
    "Tickets": "Tickets",
    "Transcripts": "Transcripts",
    "Uploads": "Uploads",
    "Users": "Users",
    "Video Generation": "Video Generation",
    "Walmart Connect": "Walmart Connect",
    "Workflows": "Workflows",
    "Trellis logo": "Trellis logo",
    "trellis": "trellis",
    "Tags": "Tags"
  },
  "Bulk edit": "Bulk edit",
  "Cancel Changes": "Cancel Changes",
  "Create new": "Create new",
  "Create new...": "Create new...",
  "Loading more...": "Loading more...",
  "Loading...": "Loading...",
  "Logout": "Logout",
  "No results": "No results",
  "Offset type": "Offset type",
  "Save Changes": "Save Changes",
  "Select color": "Select color",
  "Selected items": "Selected items",
  "Selected values": "Selected values",
  "Something went wrong. Check your connection and try again.": "Something went wrong. Check your connection and try again.",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",
  "No organization found with that id.": "No organization found with that id.",
  "Suggested:": "Suggested:",
  "{count} characters": "{count, plural, one {# character} other {# characters}}",
  "{count} / {max} characters": "{count, plural, one {# / {max} character} other {# / {max} characters}}",
  "metricTooltip": {
    "Current": "Current",
    "Compared": "Compared",
    "Absolute": "Absolute",
    "Percent": "Percent"
  },
  "metricSelector": {
    "Select {entity} {selectorType} Metrics": "Select {entity} {selectorType} Metrics",
    "Select columns": "Select columns",
    "Table": "Table",
    "Overview": "Overview",
    "Filter by category": "Filter by category",
    "Reset": "Reset",
    "Number format:": "Number format:",
    "Compact": "Compact",
    "Precise": "Precise",
    "Selected Metrics": "Selected Metrics",
    "vs": "vs",
    "Merchandising": "Merchandising",
    "Advertising": "Advertising",
    "Calculated": "Calculated",
    "Configuration": "Configuration",
    "Are you sure you want to reset current selection and ordering preferences to the default configuration?": "Are you sure you want to reset current selection and ordering preferences to the default configuration?",
    "Are you sure you want to reset current selection preferences to the default configuration?": "Are you sure you want to reset current selection preferences to the default configuration?",
    "filterOptions": {
      "All Metrics": "All Metrics",
      "Merchandising Metrics": "Merchandising Metrics",
      "Advertising Metrics": "Advertising Metrics",
      "Calculated Metrics": "Calculated Metrics",
      "Configuration Metrics": "Configuration Metrics"
    },
    "entityLabels": {
      "Media Plan": "Media Plan",
      "Pricing Plan": "Pricing Plan",
      "Category": "Category",
      "Product": "Product",
      "Organization": "Organization",
      "Target": "Target",
      "Product Advertisement": "Product Advertisement",
      "Content": "Content"
    }
  },
  "modalAlert": {
    "Error": "Error"
  },
  "navFilter": {
    "Navigation filter": "Navigation filter"
  },
  "pdfView": {
    "PDF View": "PDF View",
    "Print PDF": "Print PDF",
    "Printing Recommendations": "Printing Recommendations",
    "For the best formatting of this report, please ensure the following printing settings are configured on your computer:": "For the best formatting of this report, please ensure the following printing settings are configured on your computer:",
    "The page orientation is set to landscape": "The page orientation is set to landscape",
    "Page margins are set to \"None\"": "Page margins are set to \"None\"",
    "The \"Headers and footers\" checkbox under printing \"Options\" is unchecked": "The \"Headers and footers\" checkbox under printing \"Options\" is unchecked",
    "The \"Background graphics\" checkbox under printing \"Options\" is checked (optional, but strongly recommended)": "The \"Background graphics\" checkbox under printing \"Options\" is checked (optional, but strongly recommended)",
    "No token found": "No token found",
    "Logged in": "Logged in",
    "Welcome {userFullName}": "Welcome {userFullName}"
  },
  "pagination": {
    "Next page": "Next page",
    "Previous page": "Previous page",
    "{count} rows": "{count, plural, one {{count} row} other {{count} rows}}",
    "Page {current}": "Page {current}",
    "Page {current} of {total}": "Page {current} of {total}",
    "Page size": "Page size",
    "{start}-{end} results": "{count, plural, one {{start}-{end} result} other {{start}-{end} results}}",
    "{start}-{end} of {total} results": "{count, plural, one {{start}-{end} of {total} result} other {{start}-{end} of {total} results}}"
  },
  "No data available": "No data available",
  "Saving...": "Saving...",
  "searchBar": {
    "Search...": "Search...",
    "Enter a numeric organization id, for example org:1234.": "Enter a numeric organization id, for example org:1234."
  },
  "table": {
    "Show/hide table filters": "Show/hide table filters",
    "Reset table filters": "Reset table filters",
    "sortOptions": {
      "Default": "Default",
      "Sort Options": "Sort Options",
      "Sort options": "Sort options"
    },
    "selectAllBanner": {
      "All <strong>{count}</strong> available items selected.": "All <strong>{count}</strong> available items selected.",
      "All <strong>{count}</strong> items selected.": "All <strong>{count}</strong> items selected.",
      "All <strong>{count}</strong> available items on this page are selected.": "All <strong>{count}</strong> available items on this page are selected.",
      "All <strong>{count}</strong> items on this page are selected.": "All <strong>{count}</strong> items on this page are selected.",
      "have updates in progress and cannot be selected until these complete.": "{count, plural, one {{count} has updates in progress and cannot be selected until these complete.} other {{count} have updates in progress and cannot be selected until these complete.}}",
      "rows have updates in progress and cannot be selected.": "{count, plural, one {{count} row has updates in progress and cannot be selected.} other {{count} rows have updates in progress and cannot be selected.}}",
      "Select all {count} available items matching this filter": "Select all {count, number} available items matching this filter",
      "Select all {count} items matching this filter": "Select all {count, number} items matching this filter"
    }
  },
  "tags": {
    "Tags": "Tags"
  },
  "tagsReview": {
    "Selected tags": "Selected tags"
  },
  "Terms of Use": "Terms of Use",
  "totalSalesVendor": {
    "Total sales stats may be delayed by 3-7 days for vendors": "Total sales stats may be delayed by 3-7 days for vendors"
  },
  "upload": {
    "An error occurred": "An error occurred",
    "Invalid file type": "Invalid file type",
    "Processing...": "Processing...",
    "Uploading...": "Uploading..."
  },
  "tos": {
    "I Agree": "I Agree",
    "Please read and acknowledge our updated <termsLink>terms of service</termsLink> as of {date}.": "Please read and acknowledge our updated <termsLink>terms of service</termsLink> as of {date}.",
    "Thank you for using Trellis!": "Thank you for using Trellis!",
    "Thank you for using Trellis. Please read and acknowledge our updated terms of service as of {date}.": "Thank you for using Trellis. Please read and acknowledge our updated terms of service as of {date}.",
    "Trellis": "Trellis"
  },
  "unauthorized": {
    "Return to Dashboard": "Return to Dashboard",
    "You don't have permission to access this page": "You don't have permission to access this page"
  },
  "Yes": "Yes",
  "No": "No",
  "Show All": "Show All",
  "All Variants": "All Variants",
  "All Tags": "All Tags",
  "All Categories": "All Categories",
  "Products Selected": "{count, plural, one {# Product Selected} other {# Products Selected}}",
  "View All Options": "View All Options",
  "View Selected": "View Selected",
  "Clear All": "Clear All",
  "Toggle advanced filters": "Toggle advanced filters",
  "Sort alphabetically ascending": "Sort alphabetically ascending",
  "Sort alphabetically descending": "Sort alphabetically descending"
}
